import React, { useState } from 'react'
import "./navbar.css"
import logo from "../../assets/logo.png"

export default function Navbar() {
    const [lines, setLines] = useState("line");
    const [navbarOptions, setNavbarOptions] = useState('navbar-options');

    const closeNavbar = () => {
        setLines("line");
        setNavbarOptions('navbar-options');
    }

    const openNavbar = () => {
        setLines("line open");
        setNavbarOptions('navbar-options active');
    }

    const hamClick = () => {
        if (lines === "line") {
            openNavbar();
        } else {
            closeNavbar();
        }
    }

    return (
        <div className='navbar'>
            <div className='navbar-logo-container'>
                <img className='navbar-logo' src={logo} alt='Winterns' />
            </div>
            <div onClick={() => hamClick()} className="hamburger">
                <div className={lines}></div>
                <div className={lines}></div>
                <div className={lines}></div>
            </div>
            <div className={navbarOptions}>
                <ul>
                    <li onClick={() => closeNavbar()}><a href='/about'>About us</a></li>
                    <li onClick={() => closeNavbar()}><a href='/internships'>Internships</a></li>
                    <li onClick={() => closeNavbar()}><a href='/events'>Events</a></li>
                    <li onClick={() => closeNavbar()}><a href='/hackathons'>Hackathons</a></li>
                    <li onClick={() => closeNavbar()}><a href='/contact'>Contact Us</a></li>
                </ul>
            </div>
        </div>
    )
}
